import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { dia } from '@joint/plus';
import {
    Box, CircleStop, Clock, GitBranch, Headset, List, LucideIcon, MessageSquareMore, MessageSquareText, Play, Plug,
    Spline, Sparkles, Star, StickyNote, Tag, TextCursorInput, Ticket, Variable, Workflow, Zap,
} from 'lucide-react';
import { ShapeTypesEnum } from '../../../joint-plus/shapes/app.shapes';

// Item 11 (17/10/2026) — cabeçalho do Inspector: tipo da caixa sempre visível (a IA gera títulos livres; pelo título
// não dá pra saber o tipo). Ícone + nome do tipo; o slot `actions` recebe as ações do topo (ex.: validar fluxo).

const TYPE_META: Record<string, { icon: LucideIcon; key: string }> = {
    [ShapeTypesEnum.MESSAGE]: { icon: MessageSquareMore, key: 'inspector.type.message' },
    [ShapeTypesEnum.RESPONSE_ORIENTATION]: { icon: MessageSquareText, key: 'inspector.type.orientation' },
    [ShapeTypesEnum.RESPONSE_PARAM]: { icon: TextCursorInput, key: 'inspector.type.param' },
    [ShapeTypesEnum.SERVICE]: { icon: Plug, key: 'inspector.type.service' },
    [ShapeTypesEnum.TALK_ATTENDANT]: { icon: Headset, key: 'inspector.type.attendant' },
    [ShapeTypesEnum.FLOW]: { icon: Workflow, key: 'inspector.type.flow' },
    [ShapeTypesEnum.CREATE_TICKET]: { icon: Ticket, key: 'inspector.type.create.ticket' },
    [ShapeTypesEnum.AVALIATION]: { icon: Star, key: 'inspector.type.evaluation' },
    [ShapeTypesEnum.LLM]: { icon: Sparkles, key: 'inspector.type.llm' },
    [ShapeTypesEnum.CONDITION]: { icon: GitBranch, key: 'inspector.type.condition' },
    [ShapeTypesEnum.SET_VARIABLE]: { icon: Variable, key: 'inspector.type.set.variable' },
    [ShapeTypesEnum.TAG]: { icon: Tag, key: 'inspector.type.tag' },
    [ShapeTypesEnum.NOTE]: { icon: StickyNote, key: 'inspector.type.note' },
    [ShapeTypesEnum.BUSINESS_HOURS]: { icon: Clock, key: 'inspector.type.business.hours' },
    [ShapeTypesEnum.NATIVE_ACTION]: { icon: Zap, key: 'inspector.type.native.action' },
    [ShapeTypesEnum.INTERACTIVE_LIST]: { icon: List, key: 'inspector.type.interactive.list' },
    [ShapeTypesEnum.FLOWCHART_START]: { icon: Play, key: 'inspector.type.start' },
    [ShapeTypesEnum.FLOWCHART_END]: { icon: CircleStop, key: 'inspector.type.end' },
    [ShapeTypesEnum.LINK]: { icon: Spline, key: 'inspector.type.link' },
};

type Props = {
    cell: dia.Cell | null;
    actions?: React.ReactNode;
};

const InspectorTypeHeader = ({ cell, actions }: Props): ReactElement => {
    const intl = useIntl();
    const meta = cell ? TYPE_META[cell.get('type')] : undefined;
    const Icon = meta?.icon ?? Box;
    const typeName = !cell
        ? intl.formatMessage({ id: 'inspector.header.none' })
        : meta ? intl.formatMessage({ id: meta.key }) : String(cell.get('type') ?? '');

    return (
        <div className={'inspector-header' + (cell ? '' : ' is-empty')}>
            <div className="inspector-header-icon">
                <Icon size={18} />
            </div>
            <div className="inspector-header-text">
                <span className="inspector-header-overline">{intl.formatMessage({ id: 'inspector.header.selected' })}</span>
                <span className="inspector-header-type" title={typeName}>{typeName}</span>
            </div>
            {actions && <div className="inspector-header-actions">{actions}</div>}
        </div>
    );
};

export default InspectorTypeHeader;
